import { LocateStorePanelTitleSX } from '@/components/content/Header/styles/locateStore/parts/panelTitle';
import DynamicIcon from '@/components/icons/DynamicIcon';
import { useLocalization } from '@/data/Localization';
import { Box, IconButton, Stack, Typography, useMediaQuery, useTheme } from '@mui/material';
import {
  MATERIAL_SYMBOL_ICONS,
  OpenSansFontWeights,
} from 'shared/custom/constants/commonConstants';

type Props = {
  handleClose: () => void;
};

export const DeliveryLocatorPanelTitle = ({ handleClose }: Props) => {
  const localization = useLocalization('DeliveryLocator');
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'));

  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      sx={LocateStorePanelTitleSX.containerPadding}
    >
      <Box display="flex" alignItems="center">
        {isMobile ? (
          <DynamicIcon name={MATERIAL_SYMBOL_ICONS.locationOn} sx={LocateStorePanelTitleSX.icon} variant='filled' />
        ) : null}
        <Typography
          variant="body1"
          component={'span'}
          fontWeight={OpenSansFontWeights.semibold}
          sx={LocateStorePanelTitleSX.title}
        >
          {localization.panelDeliveryLocationTitle.t()}
        </Typography>
      </Box>
      {isMobile ? (
        <IconButton
          onClick={handleClose}
          aria-label="close"
          className="delivery-location__close"
          sx={LocateStorePanelTitleSX.cursorPointer}
        >
          <DynamicIcon name={MATERIAL_SYMBOL_ICONS.close} />
        </IconButton>
      ) : null}
    </Stack>
  );
};
